export default __webpack_public_path__ + "_/images/logo-egb-n-247aade00a9cf9a20049423ea8b9dcdae674168d1f9acb2c50127c8fdfb1ead3.svg";